import { CompanyHint } from '@/models/hints'
import { MutationTree } from 'vuex'
import { HintsState } from './state'

export enum HintsMutationTypes {
  LoadSuccess = '[Hints Mutation] Load Success',
  ViewHintSuccess = '[Hints Mutation] View Hint',
}

export type HintsLoadSuccessMutationPayload = {
  data: CompanyHint[]
}

export type ViewHintSuccessMutationPayload = {
  data: CompanyHint
}

export const mutations: MutationTree<HintsState> = {
  [HintsMutationTypes.LoadSuccess](
    state,
    payload: HintsLoadSuccessMutationPayload,
  ) {
    state.list = payload.data
  },

  [HintsMutationTypes.ViewHintSuccess](
    state,
    payload: ViewHintSuccessMutationPayload,
  ) {
    const { data } = payload

    state.list = state.list.map(item => (item.id === data.id ? data : item))
  },
}
